export const SEND_NOTIFICATION = "SEND_NOTIFICATION"

const notificationReducer = (state = {message : "",open : false, variant : "",duration:2000}, action) => {
  switch (action.type) {
    case "SEND_NOTIFICATION":
      return {
        ...state,
        message : action.payload.message,
        open : true,
        variant : action.payload.variant,
        duration: action.payload.duration || action.payload.duration,
      };
    default:
      return state;
  }
};

export default notificationReducer